exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alert{align-items:center;animation:.5s ease-in-out 0s 1 light-bounce-in;display:flex;left:0;right:0;top:1.5rem;margin:auto;max-width:30rem;position:absolute;z-index:10000;font-family:'Roboto Mono', monospace;background-color:white;border:dashed 3px white}.alert .alert-body{margin-bottom:0}.close:active,.close:focus{outline:none}@keyframes light-bounce-in{0%{opacity:0;transform:translateY(20%)}50%{transform:translateY(-5%)}100%{opacity:1;transform:translateY(0%)}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/AutoDismissAlert/AutoDismissAlert.scss
// module id = 136
// module chunks = 0